import { useContext } from 'react';
import SnackbarContext from './context';
import SnackbarProvider from './provider';

const useSnackbar = () => useContext(SnackbarContext);

export { SnackbarContext, SnackbarProvider, useSnackbar };
